var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8.75V6.25C2.5 2.7982 5.2982 0 8.75 0C12.2018 0 15 2.7982 15 6.25V8.75C16.3807 8.75 17.5 9.8693 17.5 11.25V17.5C17.5 18.8807 16.3807 20 15 20H2.5C1.1193 20 0 18.8807 0 17.5V11.25C0 9.8693 1.1193 8.75 2.5 8.75ZM12.5 6.25V8.75H5V6.25C5 4.1789 6.6789 2.5 8.75 2.5C10.8211 2.5 12.5 4.1789 12.5 6.25Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLock);
export default __webpack_public_path__ + "static/media/orange-lock.911cf5c23efad7fdf8ea710aafa3964e.svg";
export { ForwardRef as ReactComponent };